


import Formulario from '../../components/secretavotacion/verresultados'
import React, { useEffect, useState } from "react";


export default function Paginas() {
  


   
            return (
                <>
           
              <div  >
        <br/>
                <Formulario/>
                
                </div>
              
     
                
          
                </>
           
            );
        
        }